import script from "./pc-module-complex-table-6.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-complex-table-6.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-complex-table-6.vue?vue&type=style&index=0&id=eb65853e&lang=scss"

const __exports__ = script;

export default __exports__